export default __webpack_public_path__ + "static/spinner-d96300847a2bf4b09bf76a01390a452c.gif";